// extracted by mini-css-extract-plugin
export default {"sidebarWrapper":"sidebar_sidebarWrapper__Gb3Fb","sidebar":"sidebar_sidebar__uvjbL","logoWrapper":"sidebar_logoWrapper__xiGcT","navLink":"sidebar_navLink__WAAl3"};